/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */

import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import { useLocation } from '@reach/router'
import format from 'date-fns/format'
import './main.css'
import Seo from './seo'
import Header from './header'
import TopBanner from './topBanner'
import FormOne from './formOne'
import Menu from './menu'
import Features from './features'
import Footer from './footer'
import { GET_AIRPORT_SUGGESTIONS, GET_NEARBY_AIRPORT ,GET_FARE_TABLE_DATA} from '../routes'
import { PASSWORD, USERNAME } from '../constants'
import UrlParamsContext from '../contexts/urlParams'
import {
  FlightDataDispatchContext,
  FlightDataStateContext
} from '../contexts/flightData'
import {
  ReviewBannerDispatchContext,
  ReviewBannerStateContext
} from '../contexts/reviewBannerContext'

const isBrowser = typeof window !== 'undefined'

const initializeFlightData = () => {
  return {
    origin:
      isBrowser && window.sessionStorage.getItem('origin')
        ? window.sessionStorage.getItem('origin')
        : '',
    originCode:
      isBrowser && window.sessionStorage.getItem('originCode')
        ? window.sessionStorage.getItem('originCode')
        : '',
    destination:
      isBrowser && window.sessionStorage.getItem('destination')
        ? window.sessionStorage.getItem('destination')
        : '',
    destCode:
      isBrowser && window.sessionStorage.getItem('destCode')
        ? window.sessionStorage.getItem('destCode')
        : '',
    daysTrip:
      isBrowser && window.sessionStorage.getItem('daysTrip')
        ? window.sessionStorage.getItem('daysTrip')
        : 0,
    depDate:
      isBrowser && window.sessionStorage.getItem('depDate')
        ? window.sessionStorage.getItem('depDate')
        : '',
    retDate:
      isBrowser && window.sessionStorage.getItem('retDate')
        ? window.sessionStorage.getItem('retDate')
        : '',
    originCity:
      isBrowser && window.sessionStorage.getItem('originCity')
        ? window.sessionStorage.getItem('originCity')
        : '',
    destCity:
      isBrowser && window.sessionStorage.getItem('destCity')
        ? window.sessionStorage.getItem('destCity')
        : '',
    originRegion:
      isBrowser && window.sessionStorage.getItem('originRegion')
        ? window.sessionStorage.getItem('originRegion')
        : '',
    destRegion:
      isBrowser && window.sessionStorage.getItem('originRegion')
        ? window.sessionStorage.getItem('originRegion')
        : '',
    exchange: false,
    tripType: isBrowser && window.sessionStorage.getItem('tripType')
      ? window.sessionStorage.getItem('tripType')
      : 'RT',
  }
}

const Layout = ({ fareDataForTop, children }) => {
  const { search } = useLocation()
  const [metaValues, setMetaValues] = useState({})
  const [flightData, setFlightData] = useState(initializeFlightData())
  const [showMenu, setShowMenu] = useState(false)
  const [urlParams, setUrlParams] = useState(null)
  const [showReviewBanner, setShowReviewBanner] = useState(false)
  const [exchangeData, setExchangeData] = useState(false)
  const isInitialMount = useRef(true)

  const [stopExchangeApiRun, setStopExchangeApiRun] = useState(false);

  useEffect(() => {
    const updateMetaValues = params => {
      // let title = ''
      const keyword = params.keyword
        ? params.keyword
          .split('-')
          .map(e => e[0].toUpperCase() + e.substr(1))
          .join(' ')
        : ''

      // if (params.arl) {
      //   title = params[params.name ? 'name' : 'arl'].trim() + ' - Cheap Flights'
      // } else if (params.lpt) {
      //   title = params.lpt.trim()
      // } else if (params.des && params.type === 'tz') {
      //   title = 'Cheap Flights to ' + params.des
      // } else if (params.kwd) {
      //   title = params.kwd
      // } else if (params.keyword === '{keyword}' && params.des) {
      //   title = 'Cheap Flights to ' + params.des
      // } else if (params.keyword && params.keyword !== '{keyword}') {
      //   title = keyword
      // }

      // if (title.trim()) document.title = title

      if (keyword)
        setMetaValues(prevState => ({
          ...prevState,
          keywords:
            keyword +
            (params.des ? `, ${params.des.replaceAll('-', ' ')}` : ''),
          description: keyword
        }))
    }

    const searchParamsObj = {}
    const urlSearchParams = new URLSearchParams(search)
    for (const [key, value] of urlSearchParams.entries()) {
      searchParamsObj[key] = value
    }
    setUrlParams(searchParamsObj)

    updateMetaValues(searchParamsObj)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const fetchOriginDestAirportDetails = async () => {
      try {
        const airportCodes = []
        const apiRequests = []
      // ..................No need Authorization after API update.....................
        // const authorizationBasic = window.btoa(USERNAME + ":" + PASSWORD);
        // const options = {
        //   headers: {
        //     Authorization: "Basic " + authorizationBasic,
        //   },
        // };
        // .........................................................................

        //---------------prev code start-------------
        // if (urlParams.ori || (!urlParams.ori && window.sessionStorage.getItem('originCode'))) {
        //   airportCodes.push(urlParams.ori)
        //   apiRequests.push(
        //     axios.get(GET_AIRPORT_SUGGESTIONS + urlParams.ori, options)
        //   )
        // } else {
        //   airportCodes.push('_ORIGIN_')
        //   apiRequests.push(axios.get(GET_NEARBY_AIRPORT))
        // }
        //------------------end---------------

        if (urlParams.ori !== undefined) {
          airportCodes.push(urlParams.ori)
          apiRequests.push(
            axios.get(GET_AIRPORT_SUGGESTIONS + urlParams.ori)
          )
        } else if (window.sessionStorage.getItem('originCode')) {
          airportCodes.push(window.sessionStorage.getItem('originCode'))
          apiRequests.push(
            axios.get(
              GET_AIRPORT_SUGGESTIONS +
              window.sessionStorage.getItem('originCode'),
        
            )
          )
        } else {
          airportCodes.push('_ORIGIN_')
          !stopExchangeApiRun&&apiRequests.push(axios.post(GET_NEARBY_AIRPORT))
        }



        //---------------prev code start-------------
        // if (
        //   urlParams.des &&
        //   urlParams.des !== flightData.destCode &&
        //   urlParams.ori !== urlParams.des
        // ) {
        //   airportCodes.push(urlParams.des)
        //   apiRequests.push(
        //     axios.get(GET_AIRPORT_SUGGESTIONS + urlParams.des, options)
        //   )
        // } else {
        //   airportCodes.push(flightData.destCode)
        //   apiRequests.push(
        //     axios.get(GET_AIRPORT_SUGGESTIONS + flightData.destCode, options)
        //   )
        // }
        //------------------end---------------


        if (
          urlParams.des &&
          urlParams.des !== flightData.destCode &&
          urlParams.ori !== urlParams.des
        ) {
          airportCodes.push(urlParams.des)
          apiRequests.push(
            axios.get(GET_AIRPORT_SUGGESTIONS + urlParams.des)
          )
        } else {
          if (flightData.destCode !== '') {
            airportCodes.push(flightData.destCode)
            apiRequests.push(
              axios.get(
                GET_AIRPORT_SUGGESTIONS + flightData.destCode
             
              )
            )
          }
        }





        if (apiRequests.length) {
          const resArray = await Promise.all(apiRequests)

          let titleUpdateTagData=[];

          resArray.forEach((res, i) => {
            const { airportCode, cityName, countryName, region } =
              getMatchingAirportData(res.data, airportCodes[i])
                  // ...................push data into titleUpdateTagData
                  titleUpdateTagData.push({
                    airportCode: airportCode,
                    cityName: cityName,
                    urlParams: urlParams,
                  });
    
     // ..................................................
            if (
              airportCodes[i] === urlParams.ori ||
              res.config.url === GET_NEARBY_AIRPORT
            ) {
              if (airportCode) {
                setFlightData(prevState => ({
                  ...prevState,
                  origin: `${airportCode} - ${cityName}, ${countryName}`,
                  originCode: airportCode,
                  originCity: cityName,
                  originRegion: region || 'u',
                  depDate: urlParams.dep_date ? format(urlParams.dep_date, 'MM/DD/YYYY') : window.sessionStorage.getItem('depDate'),
                  retDate: urlParams.ret_date ? format(urlParams.ret_date, 'MM/DD/YYYY') : window.sessionStorage.getItem('retDate'),
                  tripType: urlParams.oneway ? urlParams.oneway : window.sessionStorage.getItem('tripType') ? window.sessionStorage.getItem('tripType') : 'RT'
                }))
              } else {
                setDefaultAirportDetails()
              }
            } else if (airportCode && airportCodes[i] === urlParams.des) {
              setFlightData(prevState => ({
                ...prevState,
                destination: `${airportCode} - ${cityName}, ${countryName}`,
                destCode: airportCode,
                destCity: cityName,
                destRegion: region || 'u',
                depDate: urlParams.dep_date ? format(urlParams.dep_date, 'MM/DD/YYYY') : window.sessionStorage.getItem('depDate'),
                retDate: urlParams.ret_date ? format(urlParams.ret_date, 'MM/DD/YYYY') : window.sessionStorage.getItem('retDate'),
                tripType: urlParams.oneway ? urlParams.oneway : window.sessionStorage.getItem('tripType') ? window.sessionStorage.getItem('tripType') : 'RT'
              }))
            }
            setTimeout(() => {
              UpdateTitleTag(titleUpdateTagData);
            }, "100");
          })
        }
      } catch (_) {
        if (!flightData.origin) setDefaultAirportDetails()
      }
    }
    //...............UPDATE TITLE TAG FUNCTION...............
    var checkValueExist = (data) => {
      if (data === null || data === undefined || data === "") {
        return false;
      } else {
        return true;
      }
    };

    const UpdateTitleTag = async (titleUpdateTag) => {
      // console.log(titleUpdateTag, "titleUpdateTag", urlParams);
      let arlTag=`Cheap Flights, Plane Tickets & Flight Booking`
      let textOnDes =`Flights - Cheap Flights, Plane Tickets & Flight Booking`;

    let defaultTitleTag =`Cheap Flights - Flight Booking & Cheap Plane Tickets`

         // .................checking  params value..........
         var arlKey = "arl" in urlParams;
         // var nameKey = "name" in urlParams;
         if (
          checkValueExist(urlParams.arl) === true &&
          checkValueExist(urlParams.name) === true
        ) {
          let title = urlParams.name.trim() + " - " + arlTag;
          document.title = title;
    
          var body = {
            params: titleUpdateTag[0].urlParams,
          };
      
          setFlightData((prevState) => ({
            ...prevState,
            updateMetaTagValue: body,
          }));
        } else if (
          checkValueExist(urlParams.arl) === true &&
          checkValueExist(urlParams.name) === false
        ) {
          let title = urlParams.arl.toUpperCase().trim() + " - " + arlTag;
          document.title = title;
    
           body = {
            params: titleUpdateTag[0].urlParams,
          };
          setFlightData((prevState) => ({
            ...prevState,
            updateMetaTagValue: body,
          }));
        } else if (
          checkValueExist(urlParams.ori) === true &&
          checkValueExist(urlParams.des) === true
        ) {
    
           body = {
            OriginairportCode: titleUpdateTag[0].airportCode,
            OriginairportCity: titleUpdateTag[0].cityName,
            destairportCode: titleUpdateTag[1].airportCode,
            destairportCity: titleUpdateTag[1].cityName,
            params: titleUpdateTag[0].urlParams,
          };
          setFlightData((prevState) => ({
            ...prevState,
            updateMetaTagValue: body,
          }));
          let newtitlevalue = `${
            titleUpdateTag[0].cityName
          } (${titleUpdateTag[0].airportCode.toUpperCase()}) to ${
            titleUpdateTag[1].cityName
          } (${titleUpdateTag[1].airportCode.toUpperCase()}) ${textOnDes}`;
    
          document.title = newtitlevalue;
        } else if (checkValueExist(urlParams.des) === true) {
    
          // console.log("des",flightData)
          if(titleUpdateTag[1]!==undefined){
    
    
          let newtitlevalue = `${titleUpdateTag[1].cityName} (${titleUpdateTag[1].airportCode}) ${textOnDes}`;
    
          document.title = newtitlevalue;
    
           body = {
            OriginairportCode: titleUpdateTag[0].airportCode,
            OriginairportCity: titleUpdateTag[0].cityName,
            destairportCode: titleUpdateTag[1].airportCode,
            destairportCity: titleUpdateTag[1].cityName,
            params: titleUpdateTag[0].urlParams,
          };
          setFlightData((prevState) => ({
            ...prevState,
            updateMetaTagValue: body,
          }));
        }else{
    
          let newtitlevalue = `${flightData.originCity} (${flightData.originCode}) ${textOnDes}`;
    
          document.title = newtitlevalue;
         
           body = {
    
            destairportCode: flightData.originCity,
            destairportCity: flightData.originCode,
            params: titleUpdateTag[0].urlParams,
          };
          setFlightData((prevState) => ({
            ...prevState,
            updateMetaTagValue: body,
          }));
    
        }
        } else {
          document.title = defaultTitleTag;
          setFlightData((prevState) => ({
            ...prevState,
            updateMetaTagValue: titleUpdateTag,
          }));
          // console.log("default")
        }
    }

       

// .................................................................

    const setDefaultAirportDetails = () => {
      setFlightData(prevState => ({
        ...prevState,
        origin: 'LAX - Los Angeles, United States',
        originCode: 'LAX',
        originCity: 'Los Angeles',
        originRegion: 'u'
      }))
    }

    const getMatchingAirportData = (data, cityCode) => {
      try {
        if (cityCode !== '_ORIGIN_') {
          const matchingAirport = data.data.find(
            e => e.airportCode === cityCode
          )
          return matchingAirport || data.data[0]
        } else {
          return {
            airportCode: data[5],
            cityName: data[3],
            countryName: data[6],
            region: data[11]
          }
        }
      } catch (_) {
        return {}
      }
    }

    if (urlParams) fetchOriginDestAirportDetails()
  }, [urlParams, exchangeData])

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false
    } else {
      window.sessionStorage.setItem('tripType', flightData.tripType)
      window.sessionStorage.setItem('origin', flightData.origin)
      window.sessionStorage.setItem('originCode', flightData.originCode)
      window.sessionStorage.setItem('originCity', flightData.originCity)
      window.sessionStorage.setItem('originRegion', flightData.originRegion)
      window.sessionStorage.setItem('destination', flightData.destination)
      window.sessionStorage.setItem('destCode', flightData.destCode)
      window.sessionStorage.setItem('destCity', flightData.destCity)
      window.sessionStorage.setItem('destRegion', flightData.destRegion)

    }
  }, [
    flightData.origin,
    flightData.originCode,
    flightData.originCity,
    flightData.originRegion,
    flightData.destination,
    flightData.destCode,
    flightData.destCity,
    flightData.destRegion,
    flightData.tripType
  ])

  useEffect(() => {
    window.sessionStorage.setItem('depDate', flightData.depDate)
    window.sessionStorage.setItem('retDate', flightData.retDate)
    window.sessionStorage.setItem('daysTrip', flightData.daysTrip)
  }, [flightData.depDate, flightData.retDate, flightData.daysTrip])

  const triggerMenu = () => {
    setShowMenu(!showMenu)
  }

  const closeMenu = () => {
    setShowMenu(false)
  }

  //----------------end-------------

  const handleStopExchangeApiRun=(data)=>{

    setStopExchangeApiRun(data)
  }

  return (
    <>
      <Seo {...metaValues} />
      <Menu showMenu={showMenu} triggerMenu={triggerMenu} />
      <div
        style={{ position: showMenu ? 'fixed' : 'relative' }}
        onClick={() => closeMenu()}
      >
        <Header />
        <TopBanner
          showReviewBanner={showReviewBanner}
          mainText={urlParams && urlParams.lpt}
          subText={urlParams && urlParams.name}
          fareDataForTop={fareDataForTop}
        />
        <FlightDataDispatchContext.Provider value={setFlightData}>
          <FlightDataStateContext.Provider value={flightData}>
            <UrlParamsContext.Provider value={urlParams}>
              <ReviewBannerDispatchContext.Provider value={setShowReviewBanner}>
                <ReviewBannerStateContext.Provider value={showReviewBanner}>
                  <FormOne isInitialMount={isInitialMount} setExchangeData={setExchangeData}
                    setStopExchangeApiRun={(data)=>handleStopExchangeApiRun(data)}
                    stopExchangeApiRun={stopExchangeApiRun} />
                  <Features />
                  {children}
                </ReviewBannerStateContext.Provider>
              </ReviewBannerDispatchContext.Provider>
            </UrlParamsContext.Provider>
          </FlightDataStateContext.Provider>
        </FlightDataDispatchContext.Provider>
      </div>
      <Footer />
    </>
  )
}

export default Layout
